import request from '@/utils/request'

export function initpage(pageName) {
  return request({
    url: '/api/home/sys/pagetable/initpage',
    method: 'get',
    params: {
      pageName: pageName
    }
  })
}






// WEBPACK FOOTER //
// ./src/api/pagetable.js